import React, { useContext } from "react";
import { ThemeContext } from "../../../context/ThemeContext";

const AuthLayout = ({ children }) => {
  const {darkMode} = useContext(ThemeContext)
  return (
    <div className="flex justify-center items-center min-h-screen" style={{backgroundColor: darkMode ? '#161e29' : 'var(--white)'}}>
      <div className="w-full">{children}</div>
    </div>
  );
};

export default AuthLayout;
